import styled from 'styled-components';
import { CounterBadge } from 'ui/badge';
import { Card } from 'ui/card';
import { SecondaryButton } from 'ui/button';
import { Tag } from 'ui/tags';
import { Link } from 'ui/links';
import {
  Body2,
  buttonShadow,
  Caption,
  colors,
  duration,
  easing,
  fontSizes,
  fontWeights,
  spacing,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { LEVEL_OPTIONS, MESSAGE_COLORS } from '../../constants';

export const StyledCard = styled(Card)`
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: 'level title title' '. body body' '. date category';
  gap: ${spacing.half};
  padding: ${spacing.threeQuarter};
  background-color: ${colors.white};
  border: 1px solid #efecec;
  border-radius: ${spacing.half};
`;

export const Description = styled(Body2)`
  grid-area: body;
  font-size: ${fontSizes.s14};
  color: ${colors.grey80};
  margin-top: ${spacing.quarter};
  margin-bottom: ${spacing.quarter};
  word-break: break-word;
`;

export const OccurrenceDate = styled(Caption)`
  grid-area: date;
  color: ${colors.textSecondary};
`;

export const MarkButton = styled(SecondaryButton)`
  grid-area: action;
  position: absolute;
  bottom: ${spacing.threeQuarter};
  right: ${spacing.threeQuarter};
  left: ${pxToRem(34)};
  width: calc(100% - ${pxToRem(48)});
  visibility: hidden;
  opacity: 0;
  transition: opacity ${duration.medium} ${easing.standard};

  ${StyledCard}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

export const PositionedCounterBadge = styled(CounterBadge)<{ level: string }>`
  grid-area: count;
  position: absolute;
  top: -${spacing.threeEights};
  right: -${spacing.threeEights};
  background-color: ${({ level }) => MESSAGE_COLORS[level || LEVEL_OPTIONS.info]};
  ${buttonShadow}
`;

export const CategoryTag = styled(Tag)`
  grid-area: category;
  padding-right: ${({ theme }) => theme.spacing.values.half};
  padding-left: ${({ theme }) => theme.spacing.values.half};
`;

export const StatusIconWrapper = styled.div`
  grid-area: level;
  display: flex;
`;

export const CardHeader = styled.div`
  position: relative;
`;

export const TitleLink = styled(Link)`
  text-decoration: none;
`;

export const Title = styled(Body2)`
  font-weight: ${fontWeights.bold};
  grid-area: title;
  margin-bottom: 0;
`;
